import React, { useState } from 'react';
import { Button, Modal, Radio, Select } from 'antd';

function EditWarningModal({ visible, setVisible }) {

  return (
    <Modal
      title='Cannot Edit Count Sheet'
      open={visible}
      onCancel={() => setVisible(false)}
      closable
      footer={[
        <Button
          className='printButton'
        >
          Okay
        </Button>
      ]}
    >
      There is an inventory in process (not in a closed status). Please close out any open inventories before editing the Count Sheet. You can make any changes you require in the open inventory and those changes will be reflected in your Count Sheet after it is closed.
    </Modal>
  )
}

export default EditWarningModal;
